/* eslint-disable import/prefer-default-export */

export function sum(a: number[]): number {
  return a.reduce((prev, curr) => prev + curr, 0);
}
